import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const AuthError: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={1.125 * size}
      viewBox="0 0 96 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 0C29.64 0 18 11.64 18 26s11.64 26 26 26 26-11.64 26-26S58.36 0 44 0zM22 26c0-12.15 9.85-22 22-22s22 9.85 22 22-9.85 22-22 22-22-9.85-22-22z"
        fill={color}
      />
      <path
        d="M4 82c0-7.732 6.268-14 14-14h48v-4H18C8.059 64 0 72.059 0 82v26h4V82zM79.172 91L68.586 80.414l2.828-2.828L82 88.17l10.586-10.585 2.828 2.828L84.828 91l10.586 10.586-2.828 2.828L82 93.828l-10.586 10.586-2.828-2.828L79.172 91z"
        fill={color}
      />
    </svg>
  );
};

export default AuthError;
